import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Xmldefs } from '../../../../../../../core/entities/xmldefs.model';
import { XmldefsService } from '../../../../../../../core/repositories/xmldefs.service';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';
import { SelectItem } from 'primeng/api';
import { Xmlfields } from '../../../../../../../core/entities/xmlfields.model';

@Injectable()
export class EditDialogsXmldefsService {

  xmldefs: Xmldefs = new Xmldefs();
  originalXmldefs: Xmldefs = new Xmldefs();

  optionsTitle: SelectItem[] = [];
  optionsTitleBase: SelectItem[] = [];

  allXmldefs: Xmldefs[] = [];
  changetitulo: boolean = false;

  titles: Xmlfields[] = new Array<Xmlfields>();

  constructor(private xmldefsService: XmldefsService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.xmldefs = data.xmldef;
    this.changetitulo = data.titulochange;

    if(this.xmldefs.title1 === null){
      this.xmldefs.title1 = new Xmlfields();
      this.xmldefs.title2 = new Xmlfields();
    }

    this.originalXmldefs = _.cloneDeep(this.xmldefs);
    console.log(data);

    return forkJoin({
        valor0: this.internalHomeService.allXmlfields(),
        valor1: this.xmldefsService.findAll()
    }).pipe(map(dataGroup => {

      this.titles = dataGroup.valor0;
      this.allXmldefs = dataGroup.valor1 as Xmldefs[];

      this.optionsTitleBase.push({value: "", label: ""});

      for(let i = 0; i < this.titles.length; i++){
        if(this.xmldefs.id === this.titles[i].xmldefId){
          this.optionsTitleBase.push({value: this.titles[i].code, label: this.titles[i].code});
        }
      }

      if (Utils.noUndfAndNull(data.xmldef)) {
        this.xmldefs = _.cloneDeep(data.xmldef);
      }

      this.optionsTitle = this.optionsTitleBase;
      this.optionsTitleBase = [];

      return true;
    }));
  }


  /**
  * @description
  * Guarda el xmldef
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.xmldefs.id, "")) {

      /*comparamos el xmldef original con el modificado*/
      let compareXmldef = this.compare(this.xmldefs, this.originalXmldefs);

      if(compareXmldef){
        return of(-1);
      }else{
        if(this.xmldefs.title1.id === null && this.xmldefs.title2.id === null){
          this.xmldefs.title1 = new Xmlfields();
          this.xmldefs.title2 = new Xmlfields();
        }
        return this.xmldefsService.postXmldef(this.xmldefs);
      }

    }else{
      this.xmldefs.title1 = new Xmlfields();
      this.xmldefs.title2 = new Xmlfields();
      return this.xmldefsService.postXmldef(this.xmldefs);
    }
  }

  /**
  * @description
  * Comprueba si dos Xmldefs son iguales.
  * @param datoX Xmldef 1
  * @param datoY Xmldef 2
  * @returns True si son iguales
  */
  public compare(itemX:Xmldefs, itemY:Xmldefs):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if(itemY.id == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.desc, itemY.desc)
        || !Utils.compareTextOrNumber(itemX.initialtag, itemY.initialtag)
        || !Utils.compareTextOrNumber(itemX.childrentag, itemY.childrentag)
        || !Utils.compareTextOrNumber(itemX.title1.code, itemY.title1.code)
        || !Utils.compareTextOrNumber(itemX.title2.code, itemY.title2.code)
        ) && (itemX.code !== ""))
          return false;
      }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.xmldefs = new Xmldefs();
  }

}
